import BaseController from "../baseController";
import { IAchievement } from "./Entities/IAchievement";

export default class AchievementController extends BaseController {
    public Get() {
        return this.MakeRequest<IAchievement[]>({
            url: `/achievements/${this.config.countryCode}`,
        });
    }
}
